(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('airCrewsCtrl', airCrewsCtrl)
        .controller('airCrewNewCtrl', airCrewNewCtrl)
        .controller('airCrewEditCtrl', airCrewEditCtrl)
        .controller('airCrewDeleteCtrl', airCrewDeleteCtrl)
        .controller('modalAddNewAirCrewCtrl', modalAddNewAirCrewCtrl);

    airCrewsCtrl.$inject = ['linkService', 'airCrews', 'tabAdminFlights'];

    airCrewNewCtrl.$inject = ['linkService', 'tabAdminFlights', 'modelAirCrafts','airCrewService'];

    airCrewEditCtrl.$inject = ['linkService', 'airCrew', 'tabAdminFlights', 'modelAirCrafts',
        'airCrewService', '$stateParams','dateService'];

    airCrewDeleteCtrl.$inject = ['$uibModalInstance', 'airCrewService','$stateParams'];

    modalAddNewAirCrewCtrl.$inject = ['$uibModalInstance', 'modelAirCrafts', 'airCrewService', 'modelAirCraft'];

    function airCrewsCtrl(linkService, airCrews, tabAdminFlights) {
        var vm = this;
        vm.pages = [];

        vm.tabs = tabAdminFlights;
        vm.linkService = linkService;
        vm.airCrews = (airCrews.data._embedded) ? airCrews.data._embedded.aircrews : [];
        vm.pages = airCrews.data.page;
    }

    function airCrewNewCtrl(linkService, tabAdminFlights, modelAirCrafts,airCrewService) {

        var vm = this;
        var currentDate = new Date();
        currentDate.setHours(1);
        vm.tabs = tabAdminFlights;
        vm.linkService = linkService;
        vm.modelAircrafts = (modelAirCrafts.data._embedded != undefined)?modelAirCrafts.data._embedded.modelAircrafts:{};
        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false
        };

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            },
            closed: function(args) {
                var valueDate = args.closeDate;
            }
        };

        vm.crew = {
            typeCrew: 0,
            phones: [
                {
                    prefix : undefined,
                    number : undefined
                }
            ]
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changeHandler = function (form) {
            if(form.expirationDate.$modelValue != undefined && !isNaN(form.expirationDate.$modelValue)){
                form.expirationDate.$setValidity('dateHigherToday', vm.crew.expirationDate.getTime() >= vm.datepickerFrom.datepickerOptions.minDate.getTime());
            }else{
                form.expirationDate.$setValidity('date', false);
            }
        }
        // CALENDAR ================================================================

        vm.cancel = function () {
            linkService.reloadRoute('airCrews', null);
        }

        vm.saveAirCrew = function (isValid, airCrew) {
            var save = {
                "name": airCrew.name,
                "lastName": airCrew.lastName,
                "nroIdentity": airCrew.nroIdentity,
                "address": airCrew.address,
                "phone": getPhone(airCrew.phones),
                "license": airCrew.license,
                "expirationDate": moment(airCrew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": (airCrew.typeCrew==0?1:2),
                "modelAircraftId":  airCrew.modeAirCraft.modelAircraftId,
                "makerId":  airCrew.modeAirCraft.makerId,
                "typeCrew": airCrew.typeCrew
            }

            if (isValid) {
                airCrewService.saveAirCrew(save);
            }
        }

        vm.addPhones = function(){
            vm.crew.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.crew.phones.splice(index, 1)
        }
    }

    function airCrewEditCtrl(linkService, airCrew, tabAdminFlights, modelAirCrafts,airCrewService, $stateParams, dateService) {
        var vm = this;

        vm.airCrew = airCrew;
        vm.tabs = tabAdminFlights;
        vm.linkService = linkService;

        vm.cancel = function () {
            linkService.reloadRoute('airCrews', null);
        }

        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false
        };

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            },
            closed: function(args) {
                var valueDate = args.closeDate;
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changeHandler = function (form) {
            if(form.expirationDate.$modelValue != undefined){
                form.expirationDate.$setValidity('dateHigherToday', vm.crew.expirationDate.getTime() >= vm.datepickerFrom.datepickerOptions.minDate.getTime());
            }else{
                form.expirationDate.$setValidity('date', false);
            }
        }
        //$element.find('airCrewForm').expirationDate.$setValidity('dateHigherToday', vm.crew.expirationDate.getTime() >= vm.datepickerFrom.datepickerOptions.minDate.getTime());
        // CALENDAR ================================================================

        vm.modelAircrafts = [];
        vm.crew = {
            "name": vm.airCrew.name,
            "lastName": vm.airCrew.lastName,
            "nroIdentity": vm.airCrew.nroIdentity,
            "address": vm.airCrew.address,
            "phone": vm.airCrew.phone,
            "phones": setPhones(vm.airCrew.phone),
            "license": vm.airCrew.license,
            "expirationDate": dateService.getDateByDateZone(vm.airCrew.expirationDate),
            "occupationCrewId": vm.linkService.getLinkId(vm.airCrew._embedded.occupationCrew._links.self.href),
            "modeAirCraft":  vm.airCrew._embedded.modelAircraft,
            "makerId":  vm.airCrew.makerId,
            "typeCrew": vm.airCrew.typeCrew
        }

        vm.modelAircrafts = modelAirCrafts.data._embedded.modelAircrafts;
        /*if(vm.crew.expirationDate.getTime() < vm.datepickerFrom.datepickerOptions.minDate.getTime()){
            vm.crew.expirationDate = undefined;
        }*/

        vm.old = angular.copy(vm.crew);
        vm.buttonSave = true;


        vm.saveAirCrew = function (isValid, airCrew) {
            var save = {
                "name": airCrew.name,
                "lastName": airCrew.lastName,
                "nroIdentity": airCrew.nroIdentity,
                "address": airCrew.address,
                "phone": getPhone(airCrew.phones),
                "license": airCrew.license,
                "expirationDate": moment(airCrew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": 1,
                "modelAircraftId":  airCrew.modeAirCraft.modelAircraftId,
                "makerId":  airCrew.modeAirCraft.makerId,
                "typeCrew": airCrew.typeCrew
            }

            if (isValid) {
                airCrewService.updateAirCrew($stateParams.id, save);
            }
        }

        vm.change = function(){
            if( vm.crew.typeCrew==vm.old.typeCrew && vm.crew.modeAirCraft!=undefined &&
                vm.crew.modeAirCraft.name==vm.old.modeAirCraft.name &&
                vm.crew.name.toUpperCase()==vm.old.name.toUpperCase() &&
                vm.crew.lastName.toUpperCase()==vm.old.lastName.toUpperCase() &&
                vm.crew.nroIdentity==vm.old.nroIdentity && vm.crew.address.toUpperCase()==vm.old.address.toUpperCase() &&
                getPhone(vm.crew.phones) == vm.old.phone && vm.crew.license==vm.old.license &&
                vm.crew.expirationDate!=undefined && vm.crew.expirationDate.getTime()==vm.old.expirationDate.getTime()){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }

        vm.addPhones = function(){
            vm.crew.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.crew.phones.splice(index, 1)
        }
    }

    function airCrewDeleteCtrl($uibModalInstance, airCrewService,$stateParams) {
        var vm = this;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.deleteOccupationCrew = function () {
            airCrewService.deleteAirCrew($stateParams.id)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }
    }

    function modalAddNewAirCrewCtrl($uibModalInstance, modelAirCrafts, airCrewService, modelAirCraft) {
        var vm = this;
        vm.modelAircrafts = (modelAirCrafts.data._embedded) ? modelAirCrafts.data._embedded.modelAircrafts : [];
        vm.crew = {
            typeCrew: 0,
            modeAirCraft: modelAirCraft,
            phones: [
                {
                    prefix : undefined,
                    number : undefined
                }
            ]
        }

        vm.datePickerOpenStatus = {
            'dateFrom': false
        };

        vm.disableSelects = true;

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            },
            closed: function(args) {
                var valueDate = args.closeDate;
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.changeHandler = function (form) {
            if(form.expirationDate.$modelValue != undefined && !isNaN(form.expirationDate.$modelValue)){
                form.expirationDate.$setValidity('dateHigherToday', vm.crew.expirationDate.getTime() >= vm.datepickerFrom.datepickerOptions.minDate.getTime());
            }else{
                form.expirationDate.$setValidity('date', false);
            }
        }

        vm.saveAddAirCrew = function (isValid, airCrew) {
            var save = {
                "name": vm.crew.name,
                "lastName": vm.crew.lastName,
                "nroIdentity": vm.crew.nroIdentity,
                "address": vm.crew.address,
                "phone": getPhone(vm.crew.phones),
                "license": vm.crew.license,
                "expirationDate": moment(vm.crew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": (vm.crew.typeCrew==0?1:2),
                "modelAircraftId":  vm.crew.modeAirCraft.modelAircraftId,
                "makerId":  vm.crew.modeAirCraft.makerId,
                "typeCrew": vm.crew.typeCrew
            }

            if (isValid) {
                airCrewService.saveAddAirCrew(save)
                    .then(function (response) {
                        $uibModalInstance.close({airCrew: response.data, typeCrew: vm.crew.typeCrew});
                    });
            }
        }

        vm.addPhones = function(){
            vm.crew.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.crew.phones.splice(index, 1)
        }
    }

    function getPhone(phones){
        var res = '';
        angular.forEach(phones, function(phone){
            res = res+(res.length==0?'':',')+phone.prefix+'-'+phone.number
        });
        return res;
    }

    function setPhones(phone){
        var res = [];
        angular.forEach(phone.split(','), function(splitPhone){
            res.push({
                'prefix': splitPhone.split('-')[0],
                'number': splitPhone.split('-')[1]
            });
        });
        return res;
    }

})();
